export const MEETING_SELECTED = "meeting_selected";
export const NEW_MEETING = "new_meeting";
export const NO_MEETING_SELECTED = "no_meeting_selected";
